import { useDispatch, useSelector } from "react-redux";
import { Button, Grid } from "@mui/material";

import { useAxios } from "../../../hooks";
import { ComponentHeader, Paper, TextField } from "../../../components";
import { alert } from "../../../redux/slices/alertSlice";

export function CreateBroadcastDetails({ formikProps }) {
  const axios = useAxios();
  const dispatch = useDispatch();

  const { activeBot } = useSelector((state) => state.memberDetails);

  return (
    <Paper>
      <Grid item xs={12}>
        <ComponentHeader
          title={"Broadcast Details"}
          subtitle={"Enter details for creating broadcast"}
          buttons={[
            formikProps.values.stagesCount === 0 && (
              <Button variant="outlined" onClick={handleCreateBroadcast}>
                Create Broadcast
              </Button>
            ),
          ]}
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          disabled={formikProps.values.stagesCount > 0}
          name="broadcastName"
          label="Broadcast Name"
          formikProps={formikProps}
        />
      </Grid>
    </Paper>
  );

  function handleCreateBroadcast() {
    axios({
      url: "/reminders/" + activeBot.ID,
      method: "POST",
      data: {
        broadcast_name: formikProps.values.broadcastName,
        stages_count: 1,
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          broadcastID: response.data.broadcast_id,
          stagesCount: 1,
        }));
        dispatch(
          alert({
            type: "success",
            message: response.message.displayMessage,
          })
        );
      }
    });
  }
}
